import { useRef } from "react";
import { cacheAssetSignature } from "../performance/asset-signature-cache";

/** Returns a function that caches the signature of an asset url for images. Returning function returns an image url */
export const useAssetSignatureCache = () => useRef(cacheAssetSignature()).current;
